import React from "react";

function EditGrayIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5974 1.8767C12.7961 1.67801 13.0319 1.5204 13.2915 1.41287C13.5511 1.30534 13.8294 1.25 14.1104 1.25C14.3913 1.25 14.6696 1.30534 14.9292 1.41287C15.1888 1.5204 15.4246 1.67801 15.6233 1.8767C15.822 2.07538 15.9796 2.31126 16.0872 2.57086C16.1947 2.83045 16.25 3.10869 16.25 3.38968C16.25 3.67066 16.1947 3.9489 16.0872 4.20849C15.9796 4.46809 15.822 4.70397 15.6233 4.90266L5.41072 15.1153L1.25003 16.25L2.38477 12.0893L12.5974 1.8767Z"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default EditGrayIcon;
